<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-user" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="t-title">{{ registration.users.last_name }}, {{ registration.users.first_name }}</div>
            <div>
                <div class="meta"><i class="fas fa-clock fa-fw mr-2"></i>{{registration.created_at | moment('MMMM Do YYYY')}}</div>
                <div class="meta"><i class="fas fa-money-check-dollar-pen fa-fw mr-2"></i>{{registration.revenue | currency}}</div>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <div class="data mt-1">
                    <data-row mini title="Type">{{registration.conf_reg_types ? registration.conf_reg_types.title : null}}</data-row>
                    <data-row mini title="Date">{{registration.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'RevenueRegistrationTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            registration: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        },
        methods: {
            openCard: function (card, props) {
                this.$openCard(card, props, this.card);
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .t-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: #e28c07;
        }

        .fa-check {
            color: green;
        }
    }
</style>
